@if (account !== null) {
  <div class="bgc-white mb-40 pt-30 pr-20 pb-40 pl-20">
    <div class="max-w-385 center-block">
      @if (logoPosition === 'top') {
        <div class="center-block max-w-120 mb-20">
          <img class="img-responsive" [src]="providerLogo()" alt="{{ getNameForProvider() }}" />
        </div>
      }
      <div class="text-narrowest text-center mb-30 center-block text-medium-black">
        @if (!sendEnabled) {
          {{ "add_PROVIDERNAME_pay_account" | translate: [getNameForProvider()] }}
        }
        @if (sendEnabled) {
          {{ "add_PROVIDERNAME_pay_account_send" | translate }}
        }
      </div>
      @for (field of getFields(); track field) {
        <div
          class="form-group max-w-385 center-block"
          [ngClass]="{ 'has-error': account?.hasError(field?.getName()) }">
          @if (field?.getName() === 'name') {
            <label for="{{ field?.getName() }}">
              {{ "label" | translate }} ({{ "optional" | translate }})
            </label>
          }
          @if (field?.getName() !== 'name') {
            <label for="{{ field?.getName() }}">
              {{ field?.getName() + (field?.isPrimary() ? "_primary_field" : "_payout_account_field") | translate }}
            </label>
          }
          <input
            [type]="'text'"
            class="form-field form-field--light"
            (input)="clearModelError(field)"
            [(ngModel)]="field.value"
            (ngModelChange)="onValueChange($event, field)"
            [id]="field?.getName()"
            [name]="field?.getName()"
            [required]="field?.isMandatory()"
            [readonly]="readonly(field) || !field.editable"
				[placeholder]="
					field?.getName() + (field?.isPrimary() ? '_primary_field' : '_payout_account_field') | translate
				"
            (focusout)="onInputFocusOut($event, field)" />
          @if (field?.getName() === account.getReceiverName().getName()) {
            <span class="form-error">
              {{ account?.getValidationError(field?.getName()) | translate }}
            </span>
          }
          @if (field?.getName() !== account.getReceiverName().getName()) {
            <span class="form-error">{{
              account?.getValidationError(field?.getName())
            }}</span>
          }
          @if (showChangeName(field)) {
            <a (click)="handleChangeName()">
              {{ "fiat_withdraw_bank_transfer_account_button_change_name" | translate }}
            </a>
          }
        </div>
      }
      @if ((isDynamictermAndConditionActive$ | async) && !sendEnabled) {
        <!-- dynamic -->
        <terms-and-conditions-updates [bundles]="bundles"></terms-and-conditions-updates>
      } @else {
        @if (showTermsSwitch) {
          <bp-switch [mb]="20" [model]="this" field="providerTerms">
            <div left class="text-light" [innerHtml]="getTerms()"></div>
          </bp-switch>
        }
      }
      @if (logoPosition === 'bottom') {
        <div class="max-w-150 mb-20">
          <img class="img-responsive" [src]="providerLogo()" alt="{{ getNameForProvider() }}" />
        </div>
      }
      <div class="container-left-right">
        <div>
          @if(account?.getId() === "") {
            <a (click)="close()">
              {{ "cancel_create_payout" | translate }}
            </a>
          } @else {
            <a (click)="delete()">
              {{ "delete_payout" | translate }}
            </a>
          }
        </div>
        <div>
          @if (isSaveAble()) {
            <button
              class="btn btn-primary btn-lg"
              type="button"
              (click)="save()"
              [ngClass]="{ disabled: isButtonDisabled }">
              {{ (account?.getId() === "" ? "create_payout_account" : "save") | translate }}
            </button>
          }
        </div>
      </div>
    </div>
  </div>
}
